module.exports = __webpack_public_path__ + "assets/muster-icon.png?a37cd811aab2221c1d9197ac85c01976";